// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder--YcuMW","title":"title--_DGul","body":"body--_RVzi","editAction":"editAction--xp04Y"};